import { Container, Row, Col } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import LoadingView from "../utilitiesStack/LoadingView.js";
import { useEffect, useState } from "react";
import { asyncActions as asyncUserActions } from "../../store/slices/userSlice.js";
import { asyncActions as tierAsyncActions } from "../../store/slices/tierSlice.js";
import {
  actions as loginActions,
  asyncActions as loginAsyncActions,
} from "../../store/slices/loginSlice";
import { useNavigate } from "react-router-dom";
import BaseHeading from "../../baseComponents/baseHeading.js";
import BaseImage from "../../baseComponents/baseImage.js";
import useTier from "../../customHooks/useTier.js";
import useBootstrap from "../../customHooks/useBootstrap.js";
import useColors from "../../customHooks/useColors.js";
import HotNotification from "../../components/HotNotification.js";
import NotVerifiedView from "../loginStack/NotVerifiedView/NotVerifiedView.js";
import WithTemplateWrapper from "../../HOC/WithTemplateWrapper.js";

const MainTemplate = ({
  //komponente lijevo i desno
  templateWrapperOptions = {},
  LeftSideComponent = () => <></>,
  MainComponent = () => <></>,
  //efekti
  getUserInfo = false,
  getTierInfo = false,
  //handling funkcije
  onEnter = () => {},
  //others
  title = null,
  image = null,
  showBadge = false,
}) => {
  //////////////////////////////////////////dispatcher and navigator
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentTier] = useTier();

  const { trashold, trashold4, trashold8 } = useBootstrap();

  ///////////////////////////////////////////theme

  const [currentColors] = useColors();

  ///////////////////////////////////////////redux state
  const globalLoadingState = useSelector((state) => state.loadingState);
  const loginState = useSelector((state) => state.loginState);

  const isPhoneVerified = loginState.login.userInfo.isPhoneVerified;
  const isMailVerified = loginState.login.userInfo.isMailVerified;

  ///////////////////////////////////////////variables driven from state

  const getTierInfoUnion = getTierInfo === true || showBadge === true;

  ///////////////////////////////////////////////EFFECTS
  ///////////////////////////////////////////////get user info
  useEffect(() => {
    let resPromise;
    if (getUserInfo) {
      resPromise = dispatch(asyncUserActions.getUserInfo());
    }

    return () => {
      if (resPromise) {
        resPromise.abort();
      }
    };
  }, []);

  ///////////////////////////////////////////////get tier info
  useEffect(() => {
    let resPromise;

    if (getTierInfoUnion) {
      resPromise = dispatch(tierAsyncActions.getTiers());
    }

    return () => {
      if (resPromise) {
        resPromise.abort();
      }
    };
  }, []);

  ///////////////////////////////////////////////check for send again verification messages - pita indikatore dal mozemo slati ponovno poruku

  useEffect(() => {
    if (isPhoneVerified === false || isMailVerified === false) {
      dispatch(
        loginAsyncActions.checkCurrentVerificationStatus({ showSuccess: false })
      );
    }

    if (isPhoneVerified === false) {
      dispatch(loginAsyncActions.canAskForSMSverificationTokenAgain(true));
    }

    if (isMailVerified === false) {
      dispatch(loginAsyncActions.canAskForMailVerificationTokenAgain(true));
    }
  }, []);

  ///////////////////////////////////////////render
  return (
    <div
      className={`p-2 p-${trashold}-0`}
      style={{
        backgroundColor: currentColors.quinary,
        height: "100%",
        flex: 1,
        flexGrow: 1,
      }}
    >
      <Container
        fluid
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            onEnter(e);
          }
        }}
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          justifyContent: "flex-start",
        }}
      >
        <Row>
          <Col {...trashold4} style={{}}>
            {title && (
              <BaseHeading bold style={{ margin: "0 20px" }}>
                {title}
              </BaseHeading>
            )}
            {image && (
              <BaseImage
                src={image.src}
                buildSrcFromConnection={image.buildSrcFromConnection ?? true}
                style={{ marginBottom: "3%", width: "100%", height: "200px" }}
              />
            )}
            {showBadge && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "0.5em",
                  marginBottom: "1em",
                  justifyContent: "center",
                }}
              >
                <BaseImage
                  style={{
                    width: "2.3em",
                  }}
                  src={currentTier?.badgeImageCode}
                />
                <BaseHeading
                  bold
                  style={{
                    color: currentTier?.color,
                  }}
                  translate={false}
                >
                  {currentTier?.name}
                </BaseHeading>
              </div>
            )}
            {LeftSideComponent()}
          </Col>
          <Col {...trashold8}>
            {/* <MainComponent
              mainTemplateOptions={{}}
              templateWrapperOptions={templateWrapperOptions}
            /> */}
            {MainComponent({
              mainTemplateOptions: {},
              templateWrapperOptions: templateWrapperOptions,
            })}
          </Col>
        </Row>
      </Container>
      {globalLoadingState.loadingBucket.length > 0 && <LoadingView />}
    </div>
  );
};

export default WithTemplateWrapper(MainTemplate);
